import {Individu} from '@Common/core/services';

export enum StatusEnseignant {
  titulaire = 1,
  vacataire = 2
}
export enum GenderEnseignant {
  male = 1,
  female = 2,
  nonbinary = 3
}
export interface Enseignant {
  id?: number;
  gender?: GenderEnseignant;
  status?: StatusEnseignant;
  individu_obj?: Individu;
  is_active?: boolean;
  user?: string;
  /**
   * Attributs pour la saisie des vacataires
   */
  first_name?: string;
  last_name?: string;
  email_pro?: string;
  phone_pro?: string;
}
